import React from "react";
import WideWhiteButton from "components/Design/Button/WideWhiteButton";
import SecondaryButton from "components/Design/Button/SecondaryButton";
import { ButtonFullWidth } from "components/Design/Button/ButtonFullWidth";
import cx from "classnames";
import PrimaryButtonFullWidth from "../Button/PrimaryButtonFullWidth";
import { Link } from "gatsby-plugin-react-i18next";
import Icon from "components/CommonIcon/Icon";
import ConditionalLink from "components/ConditionalLink";
import PropTypes from "prop-types";

const CardContactUs = ({ description, label, className, url }) => {
  return (
    <div
      className={cx(
        "flex flex-col lg:flex-row bg-section-property justify-evenly",
        className
      )}>
      <div className="text-h5 lg:text-m-h3 text-white text-center p-20 lg:py-53">
        {description}
      </div>
      <div className="grid px-20 pb-20 lg:py-50">
        <ConditionalLink link={url} className="text-center">
          <WideWhiteButton label={label} />
        </ConditionalLink>
      </div>
    </div>
  );
};

const CardContactUsPrimary = ({ description, contact, border }) => {
  return (
    <div
      className={cx(
        "p-20 bg-white  justify-evenly",
        {
          "shadow-booking-form border border-gray-light rounded-sm": border,
        },
        { "border-0": !border }
      )}>
      <div className="text-m-h4 text-gray-text-2">{description}</div>
      <div className="mt-12">
        <ConditionalLink link={contact.url}>
          <PrimaryButtonFullWidth smallText label={contact.label} />
        </ConditionalLink>
      </div>
    </div>
  );
};

CardContactUsPrimary.defaultProps = {
  border: true,
};
CardContactUsPrimary.propTypes = {
  border: PropTypes.bool,
};

const CardContactUsLight = ({ description, label, url }) => {
  return (
    <div className="flex flex-col p-20 border border-gray-light rounded-sm shadow-card-contact-us w-full">
      <div className="text-h5 text-gray-text-2 pb-12">{description}</div>
      <ConditionalLink link={url}>
        <ButtonFullWidth label={label} type="secondary" />
      </ConditionalLink>
    </div>
  );
};

const RenderLink = ({ link, children }) => {
  const isGatsbyLink = !link.startsWith("https://");

  if (isGatsbyLink) {
    return <Link to={link}>{children}</Link>;
  }

  return (
    <a href={link} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  );
};

const CardContactUsWedding = ({
  description,
  contactNo,
  contact,
  appointment,
  className,
  reachUsViaWhatsapp,
}) => {
  return (
    <div
      className={cx(
        "flex flex-col p-6 border border-gold rounded-sm w-full",
        className
      )}>
      <div class="flex flex-col w-full border border-gold p-1.375r md:p-1.625r">
        <div className="text-16-24 text-gold mx-auto text-center">
          {description}
        </div>
        <ConditionalLink
          link={`tel:${contactNo}`}
          sameTab
          className="text-12-22 text-gold my-16 mx-auto font-bold font-mulish border-b border-gold tracking-16">
          {contactNo}
        </ConditionalLink>
        {contact && (
          <div class="lg:w-320 w-full mx-auto text-12-22">
            <RenderLink link={contact.url}>
              <PrimaryButtonFullWidth smallText label={contact.label} />
            </RenderLink>
          </div>
        )}
        {reachUsViaWhatsapp && (
          <div class="lg:w-320 w-full mx-auto text-12-22">
            {reachUsViaWhatsapp}
          </div>
        )}
        {appointment && (
          <div class="md:w-320 mt-14 w-full mx-auto">
            <ConditionalLink link={appointment.url}>
              <SecondaryButton block label={appointment.label} />
            </ConditionalLink>
          </div>
        )}
      </div>
    </div>
  );
};

const CardContactUsContent = ({ label, phone, email, description }) => {
  return (
    <div className="font-mulish bg-solid-white p-16 h-full w-320">
      <h5 className="font-bold text-12-22 text-gold tracking-16 uppercase mb-2">
        {label}
      </h5>
      <ul className="text-14-24 text-gray-text">
        {phone && (
          <li className="flex items-center">
            <span className="mr-8">
              <Icon name="phone" color="text-gray-text" />
            </span>
            {phone}
          </li>
        )}
        {email && (
          <li className="flex items-center">
            <span className="mr-8">
              <Icon name="mail" color="text-gray-text" />
            </span>
            {email}
          </li>
        )}
        {description && <li className="flex items-center">{description}</li>}
      </ul>
    </div>
  );
};

export {
  CardContactUs,
  CardContactUsLight,
  CardContactUsWedding,
  CardContactUsPrimary,
  CardContactUsContent,
};
